import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { Store, select } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { FormComponent } from 'src/app/common-components/forms-base/form-component.interface';
import { CallCostDetailFormService } from '../../call-cost-details/services/call-cost-detail-form.service';
import { createProviderCallCostPreview } from '../state/add-provider-call-costs.actions';
import { getAddProviderCallCostCallState } from '../state/add-provider-call-costs.selectors';
import { AddProviderCallCostViewComponent } from '../views/add-provider-call-costs-view.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [CallCostDetailFormService],
    selector: 'ndt-add-provider-call-costs',
    templateUrl: './add-provider-call-costs.component.html',
    standalone: false
})
export class AddProviderCallCostComponent implements OnInit, OnDestroy, FormComponent {
   @ViewChild(AddProviderCallCostViewComponent) addProviderCallCostViewComponent: AddProviderCallCostViewComponent;

   callState: Observable<CallState>;

   form: UntypedFormGroup;

   private destroyed$ = new Subject<void>();

   constructor(
      protected store: Store,
      protected formService: CallCostDetailFormService,
      private dialogService: LcsDialogService
   ) {
      this.callState = this.store.pipe(select(getAddProviderCallCostCallState));
   }

   ngOnInit(): void {
      this.form = this.formService.form;
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   onCloseClick(): void {
      this.dialogService.close();
   }

   onCreate(): void {
      if (this.form.valid) {
         const file = this.form.get('File')?.value;
         const providerId = this.form.get('providerId')?.value;
         this.store.dispatch(
            createProviderCallCostPreview({
               providerCallCost: {
                  File: file,
                  providerId: providerId,
               },
            })
         );
      }
   }
}
